import { Moment, WeekdaySimpleFn } from "moment";
import Utils from "../utils";
import * as moment from "moment";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { CoreOpenDayTime } from "../../languages/openDayTime";
import { ContentType, CustomAction, ImageOrientation } from "../contentTypes";
import { orderTypes } from "./webshop.model";
import DateManager from "../dateManager";
import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";

/**
 * Attention: PortalCommon.YourApp.LocationOpenDay.DayOfWeek contains this enum and enum text and value mus be equal
 */
export enum DayOfWeek {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7
}

/** Vorlaufzeit Einheits Typ */
export enum LeadTimeType {
  /** Minuten */
  Minute = 0,
  /** Arbeitstage (ohne geschlossene Tage und Feiertage) */
  WorkDay = 1
}

export class BasketLocationViewModel {
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public street: string;
  public location: string;
  public zip: string;
  public get address(): string {
    const zipAndLocation = [this.zip, this.location].filter(s => s).join(" ");
    return [this.street, zipAndLocation].filter(s => s).join(", ");
  }
  public impressum_html_de?: string;
  public impressum_html_en?: string;
  public get impressumHtml(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.impressum_html_en) ? this.impressum_html_de : this.impressum_html_en;
  }
  public phone_no: string;
  public stnr: string;
  public ustid: string;
  public commercial_register: string;
  public local_court: string;
  public representative: string;
}

export class ServiceOpenTimeViewModel {
  public display: string;
  public value: string;
  public asap: boolean;
}

export class MenuLocationViewModel {
  public hyp_cus_nr: number;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public address: string;
}

export class MenuChangeLocationViewModel {
  public hyp_cus_nr: number;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public street: string;
  public zip: string;
  public location: string;
  public latitude: number;
  public longitude: number;
  public openTimes: string[];
  public openDays: LocationOpenDayViewModel[];
}

export class BonusLocationViewModel {
  public hyp_cus_nr: number;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public location: string;
}

export class EventLocationViewModel {
  public hyp_cus_nr: number;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
}

export class LocationViewModel {
  public hyp_cus_nr: number;
  public participate: boolean;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public get address(): string {
    const zipAndLocation = [this.zipCode, this.location].filter(s => s).join(" ");
    return [this.street, zipAndLocation].filter(s => s).join(", ");
  }
  public street: string;
  public location: string;
  public zipCode: string;
  public phone_no: string;
  public mail: string;
  public latitude: number;
  public longitude: number;
  public image_photo: string;
  public openTime_de: string;
  public openTime_en: string;
  public get openTime(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.openTime_en) ? this.openTime_de : this.openTime_en;
  };
  public sort_nr: number;
  public like: boolean;
  public hasReservation: boolean;
  public serviceBrowse: boolean;
  public serviceDelivery: boolean;
  public serviceInhouse: boolean;
  public serviceOrderahead: boolean;
  public servicePickup: boolean;
  public serviceWebvoucher: boolean;
  public serviceRetail: boolean;
  public serviceTicket: boolean;
  public locationActions?: CustomAction[] | null;
  public distance: number; // distance from current location(geoLocation)
  public get distanceString(): string {
    if (this.distance && this.distance !== 1000000) {
      return `${InternationalisationService.locale === "de" ? this.distance.toString().replace(".", ",") : this.distance.toString()} km`;
    } else {
      return "";
    }
  }
}

export class LocationDetailViewModel {
  public model: LocationDataModel;
  public hyp_cus_nr: number;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public street: string;
  public zip: string;
  public location: string;
  public get address(): string {
    const zipAndLocation = [this.zip, this.location].filter(s => s).join(" ");
    return [this.street, zipAndLocation].filter(s => s).join(", ");
  }
  public country_id: number;
  public phone_no: string;
  public mail: string;
  public homepage: string;
  public latitude: number;
  public longitude: number;
  public image_photo: string;
  public image_map: string;
  public openDays: LocationOpenDayViewModel[];
  public openDaysDelivery: LocationOpenDayViewModel[];
  public openDaysPickup: LocationOpenDayViewModel[];
  public openDaysInHause: LocationOpenDayViewModel[];
  public openDaysOrderahead: LocationOpenDayViewModel[];
  public upcomingSpecialDays: LocationOpenSpecialDayViewModel[];
  public open_days: LocationOpenDay[];
  public sort_nr: number;
  public like: boolean;
  public hasReservation: boolean;
  public locationActions?: CustomAction[] | null;
  public distance: number; // distance from current location(geoLocation)
  public get distanceString(): string {
    if (this.distance && this.distance !== 1000000) {
      return `${InternationalisationService.locale === "de" ? this.distance.toString().replace(".", ",") : this.distance.toString()} km`;
    } else {
      return "";
    }
  }
  public impressum_html_de?: string;
  public impressum_html_en?: string;
  public get impressumHtml(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.impressum_html_en) ? this.impressum_html_de : this.impressum_html_en;
  }
  public stnr: string;
  public ustid: string;
  public commercial_register: string;
  public local_court: string;
  public representative: string;
}
export class CheckoutLocationViewModel {
  public model: LocationDataModel;
  public hyp_cus_nr: number;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public street: string;
  public location: string;
  public zip: string;
  public get address(): string {
    const zipAndLocation = [this.zip, this.location].filter(s => s).join(" ");
    return [this.street, zipAndLocation].filter(s => s).join(", ");
  }
  public impressum_html_de?: string;
  public impressum_html_en?: string;
  public get impressumHtml(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.impressum_html_en) ? this.impressum_html_de : this.impressum_html_en;
  }
  public phone_no: string;
  public stnr: string;
  public ustid: string;
  public commercial_register: string;
  public local_court: string;
  public representative: string;
}


export class LocationDialogViewModel {
  public hyp_cus_nr: number;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public street: string;
  public location: string;
  public zip: string;
  public sort_nr: number;
  public like: boolean;
  public selected: boolean;
}

export class LocationWebshopViewModel {
  public model: LocationDataModel;
  public get hyp_cus_nr(): number {
    return this.model.hyp_cus_nr;
  }
  public get participate(): boolean {
    return this.model.participate;
  }
  public get label_de(): string {
    return this.model.label_de;
  }
  public get label_en(): string {
    return this.model.label_en;
  }
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public get street(): string {
    return this.model.street;
  }
  public get location(): string {
    return this.model.location;
  }
  public get zip(): string {
    return this.model.zip;
  }
  public get phone_no(): string {
    return this.model.phone_no;
  }
  public get image_photo(): string {
    return ContentType.Location + "/" + this.model.hyp_cus_nr + "_photo_" + ImageOrientation.Landscape + "/" + this.model.last_image_update_at_ymd + "/" + this.model.last_image_update_at_hms;
  }
  public get latitude(): number {
    return this.model.latitude;
  }
  public get longitude(): number {
    return this.model.longitude;
  }
  /** distance from current location(geoLocation) */
  public distance: number; // 
  /** distance from current location(geoLocation) */
  public get distanceString(): string {
    if (this.distance && this.distance !== 1000000) {
      return `${InternationalisationService.locale === "de" ? this.distance.toString().replace(".", ",") : this.distance.toString()} km`;
    } else {
      return "";
    }
  }
  /** enthält alle typen der Öffnungszeiten */
  public get openDaysList(): LocationOpenDay[] {
    return this.model.open_days;
  }
  /** enthält alle typen der Custom Tage mit Öffnungszeiten */
  public get open_specialdays(): LocationOpenSpecialDay[] {
    return this.model.open_specialdays;
  }
  /** Achtung ist die quelle für open, openDays, momentOpenTimeService */
  public serviceType: orderTypes;
  /** Achtung hierbei wird nur der serviceType berücksichtigt */
  public openDays: LocationOpenDayViewModel[];
  /** Achtung hierbei wird nur der serviceType berücksichtigt */
  public open: boolean;
  /** Achtung hierbei wird nur der serviceType berücksichtigt */
  public momentOpenTimeService: LocationOpenTime[];
  public get sort_nr(): number {
    return this.model.sort_nr;
  }
  public get mwst1(): number {
    return this.model.mwst1;
  }
  public get mwst2(): number {
    return this.model.mwst2;
  }
  public like: boolean;
  public get eMenuLocationID(): number {
    return this.model.eMenuLocationID;
  }
  public get currencySymbol(): string {
    return this.model.currencySymbol;
  }
  public get service_browse(): boolean {
    return this.model.service_browse;
  }
  public get service_pickup(): boolean {
    return this.model.service_pickup;
  }
  public get service_pickup_group(): boolean {
    return this.model.service_pickup_group;
  }
  public get service_delivery(): boolean {
    return this.model.service_delivery;
  }
  public get service_delivery_group(): boolean {
    return this.model.service_delivery_group;
  }
  public get service_inhouse(): boolean {
    return this.model.service_inhouse;
  }
  public get service_orderahead(): boolean {
    return this.model.service_orderahead;
  }
  public get service_webvoucher(): boolean {
    return this.model.service_webvoucher;
  }
  public get service_retail(): boolean {
    return this.model.service_retail;
  }
  public get service_ticket(): boolean {
    return this.model.service_ticket;
  }
  public get delivery_external_link(): string {
    return this.model.delivery_external_link;
  }
  public get pickup_lead_time_type(): LeadTimeType {
    return this.model.pickup_lead_time_type;
  }
  public get pickup_lead_time(): number {
    return this.model.pickup_lead_time;
  }
  public get pickup_beat(): number {
    return this.model.pickup_beat;
  }
  public get delivery_lead_time_type(): LeadTimeType {
    return this.model.delivery_lead_time_type;
  }
  public get delivery_lead_time(): number {
    return this.model.delivery_lead_time;
  }
  public get delivery_beat(): number {
    return this.model.delivery_beat;
  }
  public get delivery_areas(): DeliveryArea[] {
    return this.model.delivery_areas;
  }
  public get delivery_areas_polygon_map(): DeliveryAreaPolygonMap[] {
    return this.model.delivery_areas_polygon_map;
  }

  // Prüfung, ob der Standort offen ist
  public checkOpenTime(): boolean {
    const me = this;
    let isOpen = false;
    const now: moment.Moment = moment();
    const currentTimeYMD = Utils.GetYMDFromMoment(now);
    const currentTimeHMS = Utils.GetHMSFromMoment(now);

    const markYMD = me.model.GetTheoreticalOpenYMD(currentTimeYMD, currentTimeHMS, me.serviceType);
    const today = me.model.GetOpenDayForYMD(markYMD, me.serviceType);
    if (today.open) {

      for (let i = 0; i < today.times.length; i++) {
        const serviceTime = today.times[i];
        const serviceStartTime = moment(now);
        const serviceEndTime = moment(now);

        serviceStartTime.hours((serviceTime.start_hms / 10000) % 100)
          .minutes((serviceTime.start_hms / 100) % 100)
          .seconds(serviceTime.start_hms % 100);

        serviceEndTime.hours((serviceTime.end_hms / 10000) % 100)
          .minutes((serviceTime.end_hms / 100) % 100)
          .seconds(serviceTime.end_hms % 100);

        if (serviceEndTime.isBefore(serviceStartTime)) {
          if (markYMD < currentTimeYMD) {
            serviceStartTime.subtract(1, "days");
          } else {
            serviceEndTime.add(1, "days");
          }
        }
        if (now.isBefore(serviceEndTime) && now.isAfter(serviceStartTime)) {
          isOpen = true;
          break;
        }
      }
    }
    return isOpen;
  }
}

// Requests
export class CountrySyncModel extends SyncModel {
}

export class LocationSyncModel extends SyncModel {
}

// Responses
export class CountryDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public name_de: string;
  public name_en: string;
  public deleted_at_ymd: number;
  public deleted_at_hms: number;
  public get has_deleted_at(): boolean {
    return this.deleted_at_ymd > Utils.MinYMD;
  }
  public get deleted_at(): Moment {
    return Utils.GetMomentFromInt(this.deleted_at_ymd, this.deleted_at_hms);
  }
  public code: string;
  public iso_3166: string;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class CountrySyncDataModel extends SyncDataModel {
  public countries: CountryDataModel[];
  public get models(): DataModel[] { return this.countries; }
  public DeserializeType(): void {
    this._DeserializeType(CountryDataModel);
  }
}

export class LocationDataModel extends DataModel {
  public get DM_Key(): number | string { return this.hyp_cus_nr; }
  public hyp_cus_nr: number;
  public participate: boolean;
  public sort_nr: number;
  public label_de: string;
  public label_en: string;
  public street: string;
  public zip: string;
  public location: string;
  public image_photo: string;
  public country_id: number;
  public phone_no: string;
  public mail: string;
  public homepage: string;
  public open_days: LocationOpenDay[];
  public latitude: number;
  public longitude: number;
  public eMenuLocationID: number;
  public currencySymbol: string;
  /** Standard-Mehrwertsteuersatz */
  public mwst1: number;
  /** ermäßigter Mehrwertsteuersatz */
  public mwst2: number;
  /** supports browsing service */
  public service_browse: boolean;
  /** supports pickup service */
  public service_pickup: boolean;
  /** supports delivery service */
  public service_delivery: boolean;
  /** supports pickup group service */
  public service_pickup_group: boolean;
  /** supports delivery group service */
  public service_delivery_group: boolean;
  /** supports inhouse service */
  public service_inhouse: boolean;
  /** supports orderahead service */
  public service_orderahead: boolean;
  /** supports webvoucher service */
  public service_webvoucher: boolean;
  /** supports retail service */
  public service_retail: boolean;
  /** supports ticket service */
  public service_ticket: boolean;
  /** url to link to */
  public delivery_external_link: string;
  /** Abholung Vorlaufzeit (pickup_lead_time) Einheit wird in Minuten oder Tagen angegeben */
  public pickup_lead_time_type: LeadTimeType;
  /** Abholung Vorlaufzeit, die Einheit wird von pickup_lead_time_type bestimmt */
  public pickup_lead_time: number;
  /** in min */
  public pickup_beat: number;
  /** 0=kein, >0=hat prüfung */
  public pickup_timeslot_type: number;
  /** Lieferung Vorlaufzeit (delivery_lead_time) Einheit wird in Minuten oder Tagen angegeben */
  public delivery_lead_time_type: LeadTimeType;
  /** Lieferung Vorlaufzeit, die Einheit wird von delivery_lead_time_type bestimmt */
  public delivery_lead_time: number;
  /** in min */
  public delivery_beat: number;
  /** 0=kein, >0=hat prüfung */
  public delivery_timeslot_type: number;
  /** Umsatzsteuerid */
  public ustid: string;
  /** Steuernummer */
  public stnr: string;
  /** Handelsregiester Eintrag */
  public commercial_register: string;
  /** Amtsgericht */
  public local_court: string;
  /** Vertretende Person */
  public representative: string;
  /** Impressum im HTML Format DE */
  public impressum_html_de: string;
  /** Impressum im HTML Format EN */
  public impressum_html_en: string;
  public open_specialdays: LocationOpenSpecialDay[];
  public delivery_areas: DeliveryArea[];
  public delivery_areas_polygon_map: DeliveryAreaPolygonMap[];
  public visible: boolean;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public last_map_image_update_at_ymd: number;
  public last_map_image_update_at_hms: number;
  public get last_map_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_map_image_update_at_ymd, this.last_map_image_update_at_hms);
  }
  public last_map_image_update_by: number;
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;

  /** Renders open DayTime
   * @param dicOpenDayTime CoreOpenDayTime, or it can befor changed for own randering
   * @param markWeekday 1-7 to mark weekday, or 0 for not mark
   * @param fullWeekdayName use full weekdayname, else short
   */
  public GetOpenDaysAsString(dicOpenDayTime: {}, markWeekday: number, fullWeekdayName: boolean, type: orderTypes = orderTypes.allUnknown, hasClockLabel: boolean = false): string {
    if (Utils.IsNull(dicOpenDayTime)) {
      dicOpenDayTime = CoreOpenDayTime[InternationalisationService.locale];
    }
    return Visualize(this.open_days.filter(o => o.type === type), markWeekday, false, false, fullWeekdayName, dicOpenDayTime, hasClockLabel);
  }

  /** Ermittelt anhand der OpenDays, welcher Tag momentan als Öffnungstag angezeigt werden soll
  * wenn z.B. Dienstag offen ist von 9:00 bis 3:00 (des folgeatges) und aktuell ist Mittwoch 2:00, so ist Dienstag zu markieren
  * @param ymd the current day
  * @param hms the current time
  */
  public GetTheoreticalOpenYMD(ymd: number, hms: number, type: orderTypes = orderTypes.allUnknown): number {
    const prevMoment = Utils.GetMomentFromInt(ymd, hms).subtract(1, "day");
    const prevYMD = Utils.GetYMDFromMoment(prevMoment);
    const prevDay = this.GetOpenDayForYMD(prevYMD, type);
    if (prevDay && prevDay.open && prevDay.times.length > 0) {
      for (const time of prevDay.times) {
        // Start ist gröser ende, sprich ab 0Uhr bis Ende ist es der Folgetag (der gesuchte)
        if (time.start_hms > time.end_hms && hms <= time.end_hms) {
          return prevYMD;
        }
      }
    }

    // bleibt aktueller Wochentag
    return ymd;
  }

  /** Renders one DayTime
   * @param dicOpenDayTime CoreOpenDayTime, or it can befor changed for own randering
   * @param ymd the day to be rendered
   */
  public GetOpenDayTimeAsString(dicOpenDayTime: {}, ymd: number, fullWeekdayName: boolean = false, type: orderTypes = orderTypes.allUnknown, hasClockLabel: boolean = false): string {
    if (Utils.IsNull(dicOpenDayTime)) {
      dicOpenDayTime = CoreOpenDayTime[InternationalisationService.locale];
    }
    const open_day: LocationOpenDay = this.GetOpenDayForYMD(ymd, type);
    const weekday = open_day ? open_day.weekday : Utils.GetMomentFromInt(ymd).isoWeekday();
    const weekdayName: string = Utils.EnumName(DayOfWeek, weekday);
    const phWeekdayName: string = dicOpenDayTime["ph" + weekdayName + (fullWeekdayName ? "Full" : "")];
    let phOpenTime: string = VisualizeDayTime(open_day, false, dicOpenDayTime, hasClockLabel);
    if (phOpenTime.indexOf("{next-day}") > -1) {
      const nextWeekdayName: string = Utils.EnumName(DayOfWeek, weekday === 7 ? 1 : (weekday + 1));
      const phNextWeekdayName: string = dicOpenDayTime["ph" + nextWeekdayName + (fullWeekdayName ? "Full" : "")];
      phOpenTime = phOpenTime.replace("{next-day}", phNextWeekdayName);
    }
    if (fullWeekdayName) {
      phOpenTime = dicOpenDayTime["opendaytimeFormat"].replace("{0}", phWeekdayName).replace("{1}", phOpenTime);
    }
    return phOpenTime;
  }

  public GetOpenDayForYMD(ymd: number, type: orderTypes = orderTypes.allUnknown, useSpecialDays = true): LocationOpenDay {
    const isoweekday = Utils.GetMomentFromInt(ymd).isoWeekday();
    if (useSpecialDays) {
      const specialday = this.GetSpecialDayForYMD(ymd, type);
      if (specialday) {
        return {
          open: specialday.open,
          times: specialday.times,
          type: specialday.type,
          weekday: isoweekday,
        };
      }
    }
    const openDay = this.open_days.filter(o => o.type === type).find(day => day.weekday === isoweekday);
    if (openDay) {
      return openDay;
    } else {
      return { // Fallback to closed day
        open: false,
        times: [],
        type: type,
        weekday: isoweekday,
      };
    }
  }

  public GetSpecialDayForYMD(ymd: number, type: orderTypes = orderTypes.allUnknown): LocationOpenSpecialDay {
    return this.open_specialdays.find(day => day.type === type && day.specialday <= ymd && day.specialdayTo >= ymd);
  }

  public DeserializeSubTypes(): void {
    const me = this;
    // not convertet for performance, because LocationOpenDay is simple type
    //if (Array.isArray(me.open_days)) {
    //  const open_days = me.open_days;
    //  for (let i = 0; i < open_days.length; ++i) {
    //    const open_day = open_days[i];
    //    if (Object.getPrototypeOf(open_day) !== LocationOpenDay) {
    //      open_days[i] = Utils.GetExtend(new LocationOpenDay(), open_day);
    //    }
    //  }
    //}
    // not convertet for performance, because LocationOpenSpecialDay is simple type
    //if (Array.isArray(me.open_specialdays)) {
    //  const open_specialdays = me.open_specialdays;
    //  for (let i = 0; i < open_specialdays.length; ++i) {
    //    const open_specialday = open_specialdays[i];
    //    if (Object.getPrototypeOf(open_specialday) !== LocationOpenSpecialDay) {
    //      open_specialdays[i] = Utils.GetExtend(new LocationOpenSpecialDay(), open_specialday);
    //    }
    //  }
    //}
    // not convertet for performance, because DeliveryArea is simple type
    //if (Array.isArray(me.delivery_areas)) {
    //  const delivery_areas = me.delivery_areas;
    //  for (let i = 0; i < delivery_areas.length; ++i) {
    //    const delivery_area = delivery_areas[i];
    //    if (Object.getPrototypeOf(delivery_area) !== DeliveryArea) {
    //      delivery_areas[i] = Utils.GetExtend(new DeliveryArea(), delivery_area);
    //    }
    //  }
    //}
  }
}

export class LocationSyncDataModel extends SyncDataModel {
  public locations: LocationDataModel[];
  public get models(): DataModel[] { return this.locations; }
  public DeserializeType(): void {
    this._DeserializeType(LocationDataModel);
  }
}

/**  Represent the LocationOpenDay */
export class LocationOpenDay {
  /**  Weekdays as enum */
  public type: orderTypes;
  public weekday: DayOfWeek;
  public open: boolean;
  public times: LocationOpenTime[];
}

export class LocationOpenSpecialDay {
  public type: orderTypes;
  public specialday: number; // yyyyMMdd
  public specialdayTo: number; // yyyyMMdd
  public open: boolean;
  public times: LocationOpenTime[];
}

/** Represents the open time of location */
export class LocationOpenTime {
  public start_hms: number;
  public end_hms: number;
}

/** Represents a deliverable zip-location */
export class DeliveryArea {
  public zip: string; // Deliverable Zipcode
  public city: string; // Special City in ZipArea, will be empty
  public minimum_order_value: number; // Mindestbestellwert
  public delivery_fee: number; // Lieferkosten
}

/** Represents a delivery zone definition with its coordinates and the defined delivery fees for that area */
export class DeliveryAreaPolygonMap {
  public Name: string; // Name of the area
  public Coordinates: KmlCoordinate[]; // List of coordinates that span the polygon of the area
  public DeliveryFees: DeliveryFee[]; // List of delivery fees for the area
}

export class KmlCoordinate {
  public Longitude: number;
  public Latitude: number;
  public Altitude: number;
}

export class DeliveryFee {
  public ShoppingCartValue: number;
  public Amount: number;
}

/** Antwort vom YourAppServer, welche Zeitbereiche für Bestellungen nicht zur Verfügung stehen */
export class CheckTimeslotOrderAmount implements ApiResponseData {
  public not_available_timeslots: Timeslot[];

  DeserializeType(): void {
    // keine komplexen Datentypen vorhanden
  }
}

/** Zeitslot im Format YMD und HMS. Stellt den Start Zeitpunkt dar */
export class Timeslot {
  public ymd: number;
  public hms: number;
}

/** ViewModel for open time of location */
export class LocationOpenTimeViewModel {
  public start: Moment;
  public end: Moment;
  constructor(model: LocationOpenTime) {
    this.start = DateManager.GetMomentFromInt(0, model.start_hms);
    this.end = DateManager.GetMomentFromInt(0, model.end_hms);
  }
  public startToString(): string {
    return DateManager.MomentDateTimeFormatter(this.start, false, true);
  }
  public endToString(): string {
    return DateManager.MomentDateTimeFormatter(this.end, false, true);
  }
  public rangeToString(): string {
    return this.startToString() + " - " + this.endToString();
  }
}

/** ViewModel for the open times of a specific day of a location */
export class LocationOpenDayViewModel {
  public day: Moment;
  public ymd: number;
  public open: boolean;
  private _weekday: number;
  public times: LocationOpenTimeViewModel[];
  public enclosedTime: LocationOpenTimeViewModel | null;
  public ordertype: orderTypes;

  constructor(public model: LocationDataModel, day: Moment | number, ordertype: orderTypes) {
    this.ymd = (typeof day === "number") ? day : DateManager.GetYMDFromMoment(day);
    this.day = (typeof day === "number") ? DateManager.GetMomentFromInt(day) : day;
    const openday = model.GetOpenDayForYMD(this.ymd, ordertype, true);
    this.times = openday.times.map(time => new LocationOpenTimeViewModel(time));
    if (this.times.length > 0) {
      const enclosedTime = new LocationOpenTime();
      enclosedTime.start_hms = openday.times[0].start_hms;
      enclosedTime.end_hms = openday.times[0].end_hms;
      this.enclosedTime = new LocationOpenTimeViewModel(enclosedTime);
    }
    this.open = openday.open;
    this._weekday = openday.weekday;
    this.ordertype = ordertype;
  }

  public weekdayToString(): string {
    const weekdayName: string = Utils.EnumName(DayOfWeek, this._weekday);
    return CoreOpenDayTime[InternationalisationService.locale]["ph" + weekdayName + "Full"];
  }

  public timesToString(): string {
    return this.model.GetOpenDayTimeAsString(null, this.ymd, false, this.ordertype, false);
  }
}

/**  ViewModel for LocationOpenSpecialDay */
export class LocationOpenSpecialDayViewModel {
  public start: Moment;
  public end: Moment;
  public duration: number;
  public open: boolean;
  public times: LocationOpenTimeViewModel[];
  public active: boolean;
  public ordertype: orderTypes;

  constructor(public model: LocationDataModel, specialDay: LocationOpenSpecialDay, currentYMD: number) {
    this.start = DateManager.GetMomentFromInt(specialDay.specialday);
    this.end = DateManager.GetMomentFromInt(specialDay.specialdayTo);
    this.active = specialDay.specialday <= currentYMD && specialDay.specialdayTo >= currentYMD;
    this.duration = this.end.diff(this.start, "day");
    this.times = specialDay.times.map(time => new LocationOpenTimeViewModel(time));
    this.open = specialDay.open;
    this.ordertype = specialDay.type;
  }

  public dateToString(): string {
    let result = DateManager.MomentAsString(this.start, "D.MM");
    if (this.duration > 0) {
      result += " - " + DateManager.MomentAsString(this.end, "D.MM");
    }
    return result;
  }

  public timesToString(): string {
    return this.model.GetOpenDayTimeAsString(null, DateManager.GetYMDFromMoment(this.start), false, this.ordertype, false);
  }
}
/** same like Visualize in PortalCommon.YourApp.LocationOpenDays
 * @param markWeekday 1-7 for mark the day with dicOpenDayTime['weekdayMarker'] and 0 or >7 for no mark.
*/
function Visualize(open_days: LocationOpenDay[], markWeekday: number, smartDay: boolean, trySmartTime: boolean, fullWeekdayName: boolean, dicOpenDayTime: {}, hasClockLabel: boolean): string {
  let smartTime = false;
  if (open_days && trySmartTime) {  // checks can use Smart
    let canUseSmart: boolean = true;
    for (const day of open_days) {
      if (day.open && day.times.length > 0) {
        for (const time of day.times) {
          canUseSmart = (time.start_hms % 10000 === 0) && (time.end_hms % 10000 === 0);
          if (!canUseSmart) { break; } // verkürzteprüfung
        }
        if (!canUseSmart) { break; } // verkürzteprüfung
      }
    }
    smartTime = canUseSmart;
  }

  const days = new Array();
  if (open_days && smartDay) {
    let markNext: boolean = false;
    let startDay: string = "";
    let lastDay: string = "";
    let startTime: string = "";

    /** combeniert bei bedarf mehrere Tage und fügt sie dan days an */
    const addCombinedDay = () => {
      let phDayName = startDay;
      if (phDayName !== lastDay) {
        phDayName = dicOpenDayTime["opendayCombine"].replace("{0}", startDay).replace("{1}", lastDay);
      }
      let phDay = dicOpenDayTime["opendaytimeFormat"].replace("{0}", phDayName).replace("{1}", startTime);
      if (markNext) {
        phDay = dicOpenDayTime["weekdayMarker"].replace("{0}", phDay);
        markNext = false;
      }
      days.push(phDay);
    };

    for (let i = 1; i <= 7; ++i) {
      // versuche den vortag bei identischer öffnungszeit zusammen zu fassen
      const weekdayName: string = Utils.EnumName(DayOfWeek, i);
      const phWeekdayName: string = dicOpenDayTime["ph" + weekdayName + (fullWeekdayName ? "Full" : "")];
      const open_day: LocationOpenDay = open_days.find(day => day.weekday === i);
      const phOpenTime: string = VisualizeDayTime(open_day, smartTime, dicOpenDayTime, hasClockLabel);
      if (startTime !== phOpenTime) {
        if (startTime.length !== 0) {
          addCombinedDay();
        }
        startDay = phWeekdayName;
        startTime = phOpenTime;
      }
      lastDay = phWeekdayName;
      markNext = (markNext || markWeekday === i);
    }
    addCombinedDay();
  } else {
    for (let i = 1; i <= 7; ++i) {
      // durchlaufe alle 7 Wochentage
      const weekdayName: string = Utils.EnumName(DayOfWeek, i);
      const phWeekdayName: string = dicOpenDayTime["ph" + weekdayName + (fullWeekdayName ? "Full" : "")];
      const open_day: LocationOpenDay = open_days.find(day => day.weekday === i);
      let phOpenTime: string = VisualizeDayTime(open_day, smartTime, dicOpenDayTime, hasClockLabel);
      if (phOpenTime.indexOf("{next-day}") > -1) {
        const nextWeekdayName: string = Utils.EnumName(DayOfWeek, i === 7 ? 1 : (i + 1));
        const phNextWeekdayName: string = dicOpenDayTime["ph" + nextWeekdayName + (fullWeekdayName ? "Full" : "")];
        phOpenTime = phOpenTime.replace("{next-day}", phNextWeekdayName);
      }
      let phDay = dicOpenDayTime["opendaytimeFormat"].replace("{0}", phWeekdayName).replace("{1}", phOpenTime);
      if (markWeekday === i) {
        phDay = dicOpenDayTime["weekdayMarker"].replace("{0}", phDay);
      }
      days.push(phDay);
    }
  }
  return days.join(dicOpenDayTime["opendaytimeSeperator"]);
}

/** Visualize only one weekday */
function VisualizeDayTime(openDay: LocationOpenDay, smart: boolean, dicOpenDayTime: {}, hasClockLabel: boolean): string {
  const opentimeFormat: string = dicOpenDayTime[smart ? "opentimeFormatSmart" : "opentimeFormat"];

  let opentimeCombine: string = "";
  if (hasClockLabel) {
    opentimeCombine = dicOpenDayTime["opentimeCombine"];
  } else {
    opentimeCombine = dicOpenDayTime["opentimeCombineWithoutColockLabel"];
  }

  // initialisiere als geschlossen (wenn tag nicht definiert oder keine Zeiten forliegen gilt der Tag impeziet als geschlossen)
  const times = new Array();
  if (!Utils.IsNull(openDay) && openDay.open && openDay.times.length > 0) {
    openDay.times.forEach((time, index) => {
      const start: string = Utils.GetMomentFromInt(10101, time.start_hms).format(opentimeFormat);
      let end: string = "";
      if ((openDay.times.length - 1) === index && time.end_hms < time.start_hms) {
        end = "{next-day} " + Utils.GetMomentFromInt(10101, time.end_hms).format(opentimeFormat);
      } else {
        end = Utils.GetMomentFromInt(10101, time.end_hms).format(opentimeFormat);
      }
      times.push(opentimeCombine.replace("{0}", start).replace("{1}", end));
    });
  }
  // else tag bleibt geschlossen
  if (times.length > 0) {
    return times.join(dicOpenDayTime["opendaytimeSeperator"]);
  } else {
    return dicOpenDayTime["phClosed"];
  }
}
